import React from "react";
import "./story.scss";
import { Container, ProgressBar, Row, Col } from "react-bootstrap";
// import Sandaga from "./assets/images/angry_dwarves_cover.png";
// import dwarve from "../../../../assets/images/dwarve4.png";
// import dwarve1 from "../../../../assets/images/dwarve1.png";
import dwarve6 from "../../../../assets/images/dwarve6.png";
import dwarve7 from "../../../../assets/images/dwarve7.png";

import badge from "../../../../assets/images/brandpush-trust-badge.png";

import Button from "react-bootstrap/Button";

import { Parallax } from "react-parallax";

const Story = () => {
  const handleRoute = () => {
    window.open("https://discord.com/invite/QTsHxHtj9k", "_blank");
  };

  return (
    <>
      <div className="story_section">
        <div className="hero_image"></div>
        <div className="hero_text">
          {/* <h4 className="hero_headind">
            Welcome To The Mines!
          </h4>
          <p class="hero_para">Collect & Stake your Angry Dwarves & Earn Passive Income In Our $ORE Token</p> */}
        </div>
        <Container>
          <div className="mint_box">
            <Parallax
              renderLayer={(percentage) => {
                let t = percentage * 500;
              }}
            >
              <Parallax
                renderLayer={(percentage) => {
                  let t = percentage * 500;
                }}
              >
                <div className="mint_row">
                  <div className="dwarveimg">
                    <img src={dwarve7} style={{ width: "65%" }} alt="" />
                    <img
                      id="dwarve6"
                      src={dwarve6}
                      style={{ width: "65%" }}
                      alt=""
                    />

                    {/* <img src={dwarve} style={{ width: "80%", marginTop: "10%" }} alt="" /> */}
                  </div>

                  {/* <div className="mint_images">
                    <img
                      className=""
                      src={dwarve}
                    />
                  </div> */}
                  <div className="mint_desc">
                    <h4 className="mint_heading">Our Story</h4>
                    <p className="mint_subheading"></p>
                    <p className="mint_para">
                      3,333 hand drawn NFT's living on the Ethereum blockchain
                      -Dwarves battered and broken, their loot stolen… left with
                      no hope and angry hearts; the Dwarves band together to
                      create a new tribe.The Angry Dwarves Tribe.
                    </p>

                    <h4 className="mint_heading">
                      Why we started Angry Dwarves NFT
                    </h4>

                    <p className="mint_para">
                      Angry Dwarves Tribe is out to become a game-changer in the
                      market by launching a project run by the community of a
                      rugged project called Rich Dwarves Tribe. They now
                      navigate their way to recapture loot, collecting weapons,
                      tools, resources, food, and intending to find the Mines
                      and redeem themselves. <br /> <br />
                      “This is a project for the community, run by the
                      community, which is one of the most important factors to
                      us. We include the whole tribe in decision-making by way
                      of votes to keep it fair to everyone”, a representative
                      said in the statement. <br /> <br />
                      Owners of the Rich Dwarves Tribe (RDT) project took over
                      $3 million with them, leaving the whole community of
                      Dwarves with worthless NFTs. They originally sold for 0.2
                      Ethereum, which was roughly $650 at the time. Some bought
                      1, while others bought multiples. <br /> <br />A council
                      member stated, "We did not want to sit still and let this
                      get the better of us. So, some of the RDT elected
                      'Council' members pushed to save the community by creating
                      a new Discord server and started to make a plan on how to
                      take things forward".
                    </p>
                    <Button onClick={handleRoute}>Join Discord </Button>
                    <br />
                  </div>
                </div>
              </Parallax>
            </Parallax>
          </div>

          {/* <div className="que_div">
            <div className="que_heading">Meet the Dwarves</div>
            <div className="que_desc">Who is your favorite dwarve ?</div>
          </div> */}

          {/* <div
            className="badgediv"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img className="badgeimg" src={badge} onClick={handleRoute}></img>
          </div> */}
        </Container>
      </div>
    </>
  );
};

export default Story;
